$(document).on('click', '[data-property-toggle]', function(){
    _toggleLinePropetyReadonly($(this), is_readonly=false);
});

$(document).on('click', '[data-property-close]', function(){
    _toggleLinePropetyReadonly($(this), is_readonly=true);
});

$(document).on('click', '[data-property-save]', function(){
    // disable all buttons until AJAX is complete
    $('.cart__property__input-wrapper .button').attr('disabled', true);

    const line_number = $(this).attr('data-line-number');
    const $parent = $(`[data-line-item="${line_number}"]`);

    let properties = {};
    $parent.find('.cart__property__input').each(function(){
        properties[$(this).attr('name')] = $(this).val();
    });

    const quantity = $parent.find('[data-line-quantity]').val();
    const data = {
        line: line_number,
        quantity: quantity,
        properties: properties,
        sections: "cart__main"
    };

    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: 'json',
        success: function (new_cart) {
            if (new_cart.sections.cart__main) {
                $('.cart__item-list').html($(new_cart.sections.cart__main).find('.cart__item-list').html());
            }
            else {
                window.location.reload();
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            alert("Something went wrong, please try again later.");
        },
        done: function(){
            // enable buttons again
            $('.cart__property__input-wrapper .button').attr('disabled', false);
        }
    });
});

function _toggleLinePropetyReadonly($element, is_readonly){
    $element.closest('[data-line-key]').toggleClass('readonly', is_readonly)
            .find('.cart__property__input').attr('disabled', is_readonly);
}
